import { PageLayout, Title } from '../../../components';

import { LoginPage } from '@zapier/auth-pages';

export default function Login() {
  return (
    <Title title="Login">
      <PageLayout>
        <LoginPage />
      </PageLayout>
    </Title>
  );
}
